import { render, staticRenderFns } from "./_BackupTacticsTable.vue?vue&type=template&id=1e415337&scoped=true"
import script from "./_BackupTacticsTable.vue?vue&type=script&lang=ts"
export * from "./_BackupTacticsTable.vue?vue&type=script&lang=ts"
import style0 from "./_BackupTacticsTable.vue?vue&type=style&index=0&id=1e415337&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e415337",
  null
  
)

export default component.exports